import { getBifrost } from '@cars24/omniauth/dist/bifrost-core/bifrost-core';

let refreshTokenPromise = null;

export async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem('refreshToken');
    const sessionId = localStorage.getItem('sessionId');

    if (!refreshToken || !sessionId) {
      redirectToLogin();
      return false;
    }

    const bifrost = getBifrost();
    const response = await bifrost.refreshToken({
      refreshToken,
      sessionId,
    });

    if (response?.data?.access_token) {
      localStorage.setItem('accessToken', response.data.access_token);
      localStorage.setItem('refreshToken', response.data.refresh_token);
      if (response.data.session_id) {
        localStorage.setItem('sessionId', response.data.session_id);
      }
      return true;
    }

    redirectToLogin();
    return false;
  } catch (error) {
    console.error('Token refresh failed:', error);
    redirectToLogin();
    return false;
  } finally {
    refreshTokenPromise = null;
  }
}

export function getRefreshTokenPromise() {
  return refreshTokenPromise;
}

export function setRefreshTokenPromise(promise) {
  refreshTokenPromise = promise;
}

function redirectToLogin() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('sessionId');
  localStorage.removeItem('userProfile');
  localStorage.removeItem('userData');
  window.location.href = '/';
}

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
